/* unplugin-vue-components disabled */import { render } from "./why_m.vue?vue&type=template&id=8c159000"
import script from "./why_m.vue?vue&type=script&lang=js"
export * from "./why_m.vue?vue&type=script&lang=js"

import "./why_m.vue?vue&type=style&index=0&id=8c159000&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__